import React from 'react'
import { RichText as SitecoreRichText } from '@sitecore-jss/sitecore-jss-react'
import { FormField, ViewModel } from '@sitecore-jss/sitecore-jss-forms'
import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms'
import { FormFieldComponent } from '@sitecore-jss/sitecore-jss-react-forms/types/field-factory'

interface ViewModelWithProps extends ViewModel {
  richTextField: string
}

const RichText: FormFieldComponent<
  FieldProps<FormField<ViewModelWithProps>>
> = ({
  field: {
    model: { richTextField },
  },
}) => (
  <div>
    <SitecoreRichText field={{ value: richTextField }} />
  </div>
)

export default RichText
